import React from 'react';

import { AuthContext } from './context';

const AuthConsumer = props => (
  <AuthContext.Consumer>{context => props.children(context)}</AuthContext.Consumer>
);

export default AuthConsumer;
